function showGoogleelement() {
    $(".googleelement").css("display",'block')
    const languageIframe = document.getElementsByClassName(
      "goog-te-menu-frame"
    )[0].contentWindow
    languageIframe.addEventListener("click", e => {
      const dom = e.target.tagName.toLowerCase()
      if (dom === "span" || dom === "div") {
        $(".googleelement").removeAttr('style')
      }
    })
    document.addEventListener("mousedown", e => {
      $(".googleelement").removeAttr('style')
    })
  }   